import React from "react";
import { connect } from 'react-redux';

const ImportedEmployeeRow = ({ error, isLast, index }) => {
    return (
        <>
            <div
                key={`import-errors - ${index}`}
                style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", padding: '1rem', borderBottom: isLast ? undefined : 'solid rgb(244,244,244) 4px' }}
            >
                <div style={{ gridColumn: "span 2 / span 2", paddingLeft: '5rem' }}>
                    {error}
                </div>
            </div>
        </>

    )
}

const mapStateToProps = (state) => {

    return {
    }
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportedEmployeeRow)